// 加密方式
const algorithm = 'aes'
import domainConfig from '../../config/domainConfig';
import request from '@/utils/request'
// import Cookies from 'js-cookie'
export function login(params, data) {
  const url =
    window.location.href.indexOf('?') > -1
      ? '/api/v1/uaa/login' +
        window.location.href
          .slice(window.location.href.indexOf('?'))
          .replace(/#/g, window.encodeURIComponent('#'))
      : '/api/v1/uaa/login'
  return request({
    url: url,
    method: 'post',
		params,
    data,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
}
export function loginLDAP(data) {
  const url =
    window.location.href.indexOf('?') > -1
      ? '/api/v1/uaa/login/ldap' +
        window.location.href
          .slice(window.location.href.indexOf('?'))
          .replace(/#/g, window.encodeURIComponent('#'))
      : '/api/v1/uaa/login/ldap'
  return request({
    url: url,
    method: 'post',
    data,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
}
export function getInfo(accountId) {
  return request({
    url: '/api/v1/organization/employee/{accountId}/employee-detail',
    method: 'get',
    params: {
      accountId: accountId
    }
  })
}

export function logout() {
  console.log(logout, '/api/v1/uaa/logout')
  return request({
    url: '/api/v1/uaa/logout',
    method: 'get'
  })
}

// export function fetchRadom() {
//   return request({
//     url: '/api/v1/common/secret',
//     method: 'get'
//   })
// }

export function fetchAesRadom() {
  return request({
    url: '/api/v1/common/secret',
    method: 'post',
    data: {
      algorithm: algorithm
    }
  })
}

// export function getAccountId() {
//   return request({
//     url: '/api/v1/authentication/currentUser',
//     method: 'get'
//   })
// }

// export function getNcAppKey() {
//   // return request({
//   //   url: '/api/v1/uaa/getNcAppKey',
//   //   method: 'get'
//   // })
//   return new Promise((resolve, reject) => {
//     resolve({ status: 200, data: 'FFFF0000000001784689' })
//   })
// }

export function sendForgetMobile(params) {
  return request({
    url: '/api/v1/common/sms',
    method: 'get',
    params
  })
}

export function checkCodeForPassword(data) {
  return request({
    url: '/api/v1/uaa/password/security-code/verify',
    method: 'post',
    data
  })
}

export function resetPasswordAfterCheckCode(data) {
  return request({
    url: '/api/v1/uaa/password/reset',
    method: 'post',
    data
  })
}

export function fetchDomain() {
  return request({
    url: '/custom/anonymous/domain.json',
    method: 'get'
  })
}

export function authorize() {
  const url =
    window.location.href.indexOf('?') > -1
      ? '/api/v1/uaa/authorize' +
        window.location.href
          .slice(window.location.href.indexOf('?'))
          .replace(/#/g, window.encodeURIComponent('#'))
      : '/api/v1/uaa/authorize'
  return request({
    url: url,
    method: 'get',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
}

export function getPasswordPattern(data) {
  return request({
    url: '/api/v1/common/user/password/pattern',
    method: 'post',
    data
  })
}

export function changePasswordForPrimaryLogin(params, data) {
  return request({
    url: '/api/v1/uaa/password/first-login-password/update',
    method: 'post',
    params,
    data
  })
}

export function getLDAPEnabledInfo() {
  return request({
    url: '/api/v1/uaa/config',
    method: 'get'
  })
}

// 获取验证码
export function getCaptcha(params) {
 return request({
   baseURL: domainConfig[window.location.origin].UAA_API,
   url: '/api/v1/common/captcha',
   headers:{
     "accept-language":"en-xa"
   },
   method: 'get',
   params,
   responseType: 'arraybuffer'
 })
}

// 注销获取验证码
export function postLogoutCaptcha(params, data) {
  return request({
    baseURL: domainConfig[window.location.origin].UAA_API,
    url: '/api/v1/common/mobile/sms',
    method: 'post',
    headers:{
      "accept-language":"en-xa"
    },
    params,
    data
  })
}

// 注销用户
export function postLogoutUser(data) {
  return request({
    baseURL: domainConfig[window.location.origin].MOBILE_API,
    headers:{
      "accept-language":"en-xa"
    },
    url: '/web/user/webCancel',
    method: 'post',
    data
  })
}

// 登录获取验证码
export function getLoginCaptcha(params) {
  return request({
    url: '/api/v1/common/captcha',
    headers:{
      "accept-language":"en-xa"
    },
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js